import { apiGet, apiPost } from './client.js';

export function register(email, password) { return apiPost('/api/auth/register', { email, password }); }
export function login(email, password) { return apiPost('/api/auth/login', { email, password }); }
export function refresh(refreshToken) { return apiPost('/api/auth/refresh', { refresh_token: refreshToken }); }
export function logout(refreshToken) { return apiPost('/api/auth/logout', { refresh_token: refreshToken }); }
export function getProfile() { return apiGet('/api/users/me'); }
